import { render } from "./DataAnalytics.vue?vue&type=template&id=09b3ac2f"
import script from "./DataAnalytics.vue?vue&type=script&lang=js"
export * from "./DataAnalytics.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__